export default function getVerificationInfo(data) {
    return data
        ? "Required"
        : "Not Required";
}
